module.exports = __webpack_public_path__ + "img/5N.6ce7bb55.png";